import React from 'react'
import { FixedSizeList as List, ListChildComponentProps } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'

interface TbodyComponentProps {
  children?: React.ReactNode
}

type RowData = React.ReactElement[]

const Row = ({ index, style, data }: ListChildComponentProps) => <div style={style}>{(data as RowData)[index]}</div>

const TbodyComponent = (props: TbodyComponentProps) => {
  const rows: RowData = (Array.isArray(props.children) ? props.children[0] : []) as RowData

  return (
    <AutoSizer>
      {({ height, width }) => (
        <List itemCount={rows.length} itemSize={55} height={height} width={width} itemData={rows}>
          {Row}
        </List>
      )}
    </AutoSizer>
  )
}

export default TbodyComponent
